import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { ButtonLink } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { VehicleCard } from '../VehicleCard';
import { useVehicles } from '../../contexts/VehiclesContext';
export function CatalogoPreview() {
  const {
    vehicles
  } = useVehicles();
  const conDestacados = vehicles.filter(v => v.destacado);
  const destacados = (conDestacados.length > 0 ? conDestacados : vehicles).slice(0, 6);
  return <Section id="catalogo" data-id="element-247" data-mp="3l20l5p0ta4xl">
      <Reveal data-id="element-248" data-mp="3l1qvy3nlc1sy">
        <SectionHeading title="Catálogo VCARS" lead="Usados seleccionados y 0KM revisados unidad por unidad, con precio y estado publicados de forma clara." action={<ButtonLink to="/catalogo" variant="outline" size="lg" data-id="element-250" data-mp="3bbfq2bkcjijf">
              Ver catálogo completo
            </ButtonLink>} data-id="element-249" data-mp="3l3bqht9wnkqt" />
      </Reveal>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-251" data-mp="7vqqfnuu53t4">
        {destacados.map((v, i) => <Reveal key={v.id} delay={Math.min(i, 3) * 0.04} className="h-full" data-id="element-252" data-mp="32fq1w7flt60g" data-mpi={i}>
            <VehicleCard vehicle={v} data-id="element-253" data-mp="37fcr7f8picpm" />
          </Reveal>)}
      </div>
    </Section>;
}